import {Ability, AbilityBuilder, defineAbility, MongoAbility} from '@casl/ability';
import {PermissionAction, ResourceName, Role, UserAuthData, UserType} from "../features/auth/types";
import {PERMISSION_ACTIONS, RESOURCES} from "../config/permissions";

export interface PermissionObject {
    [key: string]: any
}

export type AppAbility = MongoAbility<[PermissionAction, ResourceName]>;
export default defineAbility<AppAbility>((can, cannot) => {
    const user = JSON.parse(localStorage.getItem('user') || "{}") as UserAuthData;
    if (user && user.profile) {
        setAbilities(user.profile.roles, can, user.profile.type)
    }
});

export function updateAbility(ability: MongoAbility, roles: Role[], userType?: UserType) {
    const {can, rules} = new AbilityBuilder(Ability);
    setAbilities(roles, can, userType);
    ability.update(rules);
}



function setAbilities(roles: Role[], can: any, userType?: UserType) {
    const hasSimplifiedInterface = roles.some((role) => role.simplifiedInterface)
    const isAdminAccount = userType === 'admin' || userType === 'api_user'

    // MediumAccessManagement is gated strictly by the account type (admin / api_user,
    // as in the backend policy) or the explicit operation; it is intentionally NOT
    // granted by an "allow" default policy.
    // The simplified interface never exposes it, even with the operation assigned.
    const hasMediumAccessOperation = roles.some((role) => role.operations?.some(operation => operation.resourceName === 'MediumAccessManagement' && operation.action === 'update'))
    if (!hasSimplifiedInterface && (isAdminAccount || hasMediumAccessOperation)) {
        can('update', 'MediumAccessManagement')
    }

    if (hasSimplifiedInterface) {
        can('access', 'SimplifiedInterface')
        can('index', 'Creation')
        can('update', 'Creation')
        can('create', 'Creation')
        can('index', 'MediabankResource')
        can('index', 'Emission')
        if (roles.some((role) => role.operations.some(operation => operation.resourceName === 'Impression' && operation.action === 'index'))) {
            can('index', 'Impression')
        }

        if (roles.some((role) => role.operations.some(operation => operation.resourceName === 'Creation' && operation.action === 'show'))) {
            can('show', 'Creation')
        }

        if (roles.some((role) => role.operations.some(operation => operation.resourceName === 'Emission' && operation.action === 'show'))) {
            can('show', 'Emission')
        }
        return
    }

    if (roles.some((role) => role.defaultPolicy === 'allow')) {
        RESOURCES.forEach((resource: ResourceName) => {
            PERMISSION_ACTIONS.forEach((action: PermissionAction) => {
                can(action, resource)
            })
        })
        can('access', 'shortPath')
    } else {
        const permissions: PermissionObject = {}
        roles.forEach(role => {
            role.operations.forEach(operation => {
                permissions[operation.resourceName] = {
                    ...permissions[operation.resourceName],
                    [operation.action]: ''
                }
            })
        })
        for (const resource in permissions) {
            for (const action in permissions[resource]) {
                can(action, resource)
            }
        }
    }
}
